var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverviewIcon8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 228.87 197.16",
    style: {
      enableBackground: "new 0 0 228.87 197.16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 4,
      strokeMiterlimit: 10,
      strokeDasharray: 2
    },
    x1: 175.4,
    y1: 89.22,
    x2: 175.4,
    y2: 108.44
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    x1: 104.44,
    y1: 45.61,
    x2: 105.44,
    y2: 45.61
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 4,
      strokeMiterlimit: 10,
      strokeDasharray: "1.9435,1.9435"
    },
    x1: 107.38,
    y1: 45.61,
    x2: 121.96,
    y2: 45.61
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    x1: 122.93,
    y1: 45.61,
    x2: 123.93,
    y2: 45.61
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_394_00000012460475646773180380000007293703009788090498_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: " M5.81,108.44h94.31c2.38,0,4.31,1.93,4.31,4.31v78.59c0,2.38-1.93,4.31-4.31,4.31H5.81c-2.38,0-4.31-1.93-4.31-4.31v-78.59 C1.5,110.37,3.43,108.44,5.81,108.44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_394_00000095337648955744637220000009597666285696705943_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: " M5.81,2h94.31c2.38,0,4.31,1.93,4.31,4.31v78.59c0,2.38-1.93,4.31-4.31,4.31H5.81c-2.38,0-4.31-1.93-4.31-4.31V6.31 C1.5,3.93,3.43,2,5.81,2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_394_00000150104860978693386370000013375885293845293204_",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: " M128.24,108.44h94.31c2.38,0,4.31,1.93,4.31,4.31v78.59c0,2.38-1.93,4.31-4.31,4.31h-94.31c-2.38,0-4.31-1.93-4.31-4.31v-78.59 C123.93,110.37,125.86,108.44,128.24,108.44z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 4,
      strokeMiterlimit: 10,
      strokeDasharray: 2
    },
    x1: 123.93,
    y1: 152.05,
    x2: 104.44,
    y2: 152.05
  }), /*#__PURE__*/React.createElement("g", {
    className: "overview-icon8-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "overview-icon8-box-outline",
    id: "Rectangle_394_00000000923649183535604450000009384941040608486068_",
    style: {
      fill: "none",
      stroke: "#E39F5C",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: " M128.24,2h94.31c2.38,0,4.31,1.93,4.31,4.31v78.59c0,2.38-1.93,4.31-4.31,4.31h-94.31c-2.38,0-4.31-1.93-4.31-4.31V6.31 C123.93,3.93,125.86,2,128.24,2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F09C4E"
    },
    d: "M177.71,29.33v-4.54h-23.09v0h-0.04v23.1h4.54V29.33H177.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F09C4E"
    },
    d: "M173.08,61.89v4.54h23.1l0,0h0.04v-23.1h-4.54v18.55H173.08z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.41,41.46v-0.24h-8.24v-3.39h12.36v3.39l-6.66,13.57h-4L177.41,41.46z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon8);
export default __webpack_public_path__ + "static/media/overview-icon8.3988f84a.svg";
export { ForwardRef as ReactComponent };